export default {
    'cm': 'Centrum Mediów AGH',
    'organization': 'Radio1.7',
    'privacy-policy': 'Polityka prywatności'
}
